import React, { useState } from 'react';
import '../styles/Topbar.css';

const Topbar = ({ user, onLogout, pageTitle, breadcrumb, onMenuToggle }) => {
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const handleLogoutClick = () => {
    setShowLogoutDialog(true);
  };

  const handleConfirmLogout = () => {
    setShowLogoutDialog(false);
    onLogout();
  };

  const handleCancelLogout = () => {
    setShowLogoutDialog(false);
  };

  return (
    <>
      <div className="topbar">
        <div className="topbar-left">
          <button className="menu-toggle-btn" onClick={onMenuToggle}>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
          
          <div className="topbar-title-section">
            <h1 className="page-title">{pageTitle || 'Affiliate Dashboard'}</h1>
            <div className="breadcrumb">
              {breadcrumb || 'Portal > Dashboard > Overview'}
            </div>
          </div>
        </div>
        
        <div className="topbar-right">
          <div className="user-info">
            <span className="user-name">{user?.first_name + ' ' + user?.last_name || 'Affiliate User'}</span>
            <button className="logout-btn" onClick={handleLogoutClick}>
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Custom Logout Confirmation Dialog */}
      {showLogoutDialog && (
        <div className="logout-dialog-overlay">
          <div className="logout-dialog">
            <div className="logout-dialog-header">
              <h3>Confirm Logout</h3>
            </div>
            <div className="logout-dialog-body">
              <p>Are you sure you want to log out?</p>
            </div>
            <div className="logout-dialog-footer">
              <button className="cancel-btn" onClick={handleCancelLogout}>
                Cancel
              </button>
              <button className="confirm-btn" onClick={handleConfirmLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Topbar;